const DOMAIN_FAVICON_MAP = {
  'www.sctp.com.tr': require('../static/img/favicons/sctp.ico'),
  'sctp.com.tr': require('../static/img/favicons/sctp.ico'),

  'bigu.birlesikgumrukleme.com.tr': require('../static/img/favicons/bigu.ico'),

  // dev
  localhost: require('../static/img/favicons/bigu.ico'),
  '127.0.0.1': require('../static/img/favicons/bigu.ico'),
};

export default DOMAIN_FAVICON_MAP;
